// Copyright (c) 2015, Neo Pacific Pvt. Ltd. and Contributors
// MIT License. See license.txt

if (nxf.require) {
	nxf.require("file_uploader.bundle.js");
} else {
	nxf.ready(function () {
		nxf.require("file_uploader.bundle.js");
	});
}
